import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import SignUp from './pages/SignUp';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import HomePage from './pages/HomePage';
import PrivateRoute from './components/layout/PrivateRoute/PrivateRoute';
import PersonalizedPage from './pages/PersonalizedPage.js';
import UserProfile from './pages/UserProfile';
import { ThemeProvider } from './context/ThemeContext';
import { getSubdomain } from './utils/getSubdomain';
import ThemeToggle from './components/ui/ThemeToggle/ThemeToggle';
import Navbar from './components/layout/Navbar/Navbar';
import { useLocation } from 'react-router-dom';
import React, { useState } from 'react';
import { useTheme, useMediaQuery } from '@mui/material';
import { LanguageProvider } from './context/LanguageContext';
import { Box } from '@mui/material';
import ChangeLanguage from './components/ui/LanguageSelector/ChangeLanguage';
import Footer from './components/Footer/Footer';

import Error from './pages/Error';

function App() {
  const subdomain = getSubdomain();

  const Layout = ({ children }) => {
    const location = useLocation();
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('md'));
    const [drawerOpen, setDrawerOpen] = useState(false);

    const toggleDrawer = () => {
      setDrawerOpen(!drawerOpen);
    };

    const hiddenRoutes = ['/'];
    const isHiddenRoute = hiddenRoutes.includes(location.pathname);

    return (
      <Box
        sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}
      >
        {!isHiddenRoute ? (
          <Navbar
            isMobile={isMobile}
            toggleDrawer={toggleDrawer}
            drawerOpen={drawerOpen}
          />
        ) : (
          <>
            <ChangeLanguage isMobile={isMobile} variant="solo" />
            <ThemeToggle variant="solo" />
          </>
        )}
        <Box
          component="main"
          sx={{
            flexGrow: 1,
            width: '100%',
          }}
        >
          {children}
        </Box>
        {!isHiddenRoute && <Footer />}
      </Box>
    );
  };

  const AppContent = () => (
    <>
      <Layout>
        <Routes>
          {subdomain ? (
            <Route
              path="/*"
              element={<PersonalizedPage subdomain={subdomain} />}
            />
          ) : (
            <>
              <Route
                path="/dashboard"
                element={<PrivateRoute component={Dashboard} />}
              />
              <Route
                path="/profile"
                element={<PrivateRoute component={UserProfile} />}
              />
              <Route path="/signup" element={<SignUp />} />
              <Route path="/login" element={<Login />} />
              <Route path="/" element={<HomePage />} />
              <Route path="*" element={<Error />} />
            </>
          )}
        </Routes>
      </Layout>
    </>
  );

  return (
    <ThemeProvider>
      <LanguageProvider>
        <Router
          future={{
            v7_startTransition: true,
            v7_relativeSplatPath: true,
          }}
        >
          <AppContent />
        </Router>
      </LanguageProvider>
    </ThemeProvider>
  );
}

export default App;
